import {
  ConferenceCall,
  DeepPartial,
  Post,
  PostCreated,
  PostLocation,
  PostType,
} from 'lib/_types'
import { ContextSchema, SchemaDetail, schemaPath } from './types'

// Schema for Post context
const POST_SCHEMA: SchemaDetail = {
  vendor: 'space.yay',
  name: 'post',
  format: 'jsonschema',
  version: '1-0-1',
}

export type PostContextSchemaData = {
  position?: number // An index position of post on the screen. Ads post is excluded from this context.
  post_id: number // A content Post ID
  author_id: number // A user ID of the post author
  post_type: PostType // A type of post. Follow a value from Yay Server's post.post_type
  likes?: number // Number of likes this post has,
  reply?: number // Number of replies this post has
  repost?: number // Number of reposts this post has
  report?: number // Number of reports this post has
  location: PostLocation // Location of the call. Either Timeline or Group
}

export const postContextSchema = (
  data: PostContextSchemaData
): ContextSchema<PostContextSchemaData> => ({
  schema: schemaPath(POST_SCHEMA),
  data,
})

export const postToPostContextSchema = ({
  post,
  position,
  location,
}: {
  post?: DeepPartial<Post>
  position?: number
  location?: PostLocation
}): PostContextSchemaData => {
  if (!post?.id) return

  return {
    position,
    post_id: post?.id,
    author_id: post?.user?.id ?? 0,
    post_type: post?.post_type,
    likes: post?.likes_count,
    // reply: 0,
    repost: post?.reposts_count,
    report: post?.reported_count,
    location: location ?? (post?.group_id ? 'group' : 'timeline') ?? 'timeline',
  }
}

export const postCreatedToPostContextSchema = ({
  post,
  userId = 0,
  location = 'timeline',
}: {
  post?: PostCreated
  userId?: number
  location?: PostLocation
}): PostContextSchemaData => {
  if (!post?.id || !post?.post_type) return

  return {
    post_id: post.id,
    author_id: userId,
    post_type: post.post_type,
    location,
  }
}

export const conferenceCallToPostContextSchema = ({
  conference,
  userId = 0,
  location = 'timeline',
}: {
  conference?: ConferenceCall
  userId?: number
  location?: PostLocation
}): PostContextSchemaData => {
  if (!conference) return

  return {
    post_id: conference.post_id,
    author_id: userId,
    post_type: 'call',
    location,
  }
}
